import type { LearningObjectiveCategory } from 'bundles/author-learning-objectives/types';
import Categories from 'bundles/learner-learning-objectives/constants/Categories';

class StoredLearningObjective {
  /**
   * config hash containing:
   * = category
   *   - string value of key for {EnumValue} Category lookup
   *   - {EnumValue} Category
   * = description
   *   - {string} description
   */

  declare id: string;

  declare category: { value: LearningObjectiveCategory };

  declare description: string;

  constructor({
    id,
    category,
    description,
  }: {
    id: string;
    category: string | { value: LearningObjectiveCategory };
    description: string;
  }) {
    this.id = id;
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'EnumValue | { value: LearningObjectiveCatego... Remove this comment to see the full error message
    this.category = typeof category === 'string' ? Categories().get(category) : category;
    this.description = description || '';
  }

  getDescription() {
    return this.description;
  }

  toJson() {
    return {
      category: this.category.value,
      description: this.description,
    };
  }
}

export default StoredLearningObjective;
